// extracted by mini-css-extract-plugin
export default {"p_content":"ca63f65e71"};